import React from "react";
import { injectIntl } from "react-intl";
import TypeaheadBox from "../Form/TypeaheadBox";
import { withApi, apiShape, withNotifier, notifierShape } from "../../context";
import { extractProductCategoryItem, sortBy } from "../../utils";
import intlShape from "../../shapes/intlShape";

type OwnProps = {
  api: apiShape;
  notifier: notifierShape;
  name: string;
  tenantId?: number;
  intl: intlShape;
  values: {
    category?: $TSFixMe;
  };
  setFieldValue: $TSFixMeFunction;
};

const defaultProps: Partial<OwnProps> = {
  // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'number | un... Remove this comment to see the full error message
  tenantId: null,
};

type Props = OwnProps & typeof defaultProps;

export function ProductCategoryTypeahead(props: Props) {
  const [categories, setCategories] = React.useState();
  const [fetching, setFetching] = React.useState();

  const { api, notifier, intl, values, name, setFieldValue, tenantId } = props;

  let selectedCategory = null;
  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  if ((values[name] as $TSFixMe)?.parent) {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    selectedCategory = extractProductCategoryItem(values[name]);
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    values[name] = selectedCategory;
  }

  const extractProductCategories = (allCategories: $TSFixMe) => {
    const mappedCategories = allCategories.categories.map(
      (category: $TSFixMe) => extractProductCategoryItem(category),
    );
    setCategories(sortBy(mappedCategories, "name"));
  };

  const extractTenant = (allPublicTenants: $TSFixMe) =>
    allPublicTenants.tenants.map((tenant: $TSFixMe) => tenant.id);

  const loadProductCategories = async (searchText = "") => {
    if (categories) {
      setFieldValue(name, null);
    }
    try {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'true' is not assignable to param... Remove this comment to see the full error message
      setFetching(true);

      const responsePublicTenants = await (api as $TSFixMe).getAll(
        "/tenants?public=true",
      );
      const publicTenants =
        responsePublicTenants?.tenants?.length > 0
          ? extractTenant(responsePublicTenants).toString()
          : "";

      let include = tenantId
        ? {
            include: "tenant,parent",
            tenant_id: `${publicTenants},${tenantId}`,
          }
        : { include: "tenant,parent", tenant_id: `${publicTenants}` };
      if (searchText) {
        // @ts-expect-error TS(2322) FIXME: Type '{ name: string; include: string; tenant_id: ... Remove this comment to see the full error message
        include = { ...include, name: `*${searchText}*` };
      }
      const response = await (api as $TSFixMe).getAll(
        "/product/categories",
        include,
      );
      if (response && response.categories) {
        extractProductCategories(response);
      } else {
        // @ts-expect-error TS(2345) FIXME: Argument of type 'never[]' is not assignable to pa... Remove this comment to see the full error message
        setCategories([]);
      }
    } catch (error) {
      (notifier as $TSFixMe).showError((api as $TSFixMe).translateError(error));
    } finally {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'false' is not assignable to para... Remove this comment to see the full error message
      setFetching(false);
    }
  };

  React.useEffect(() => {
    loadProductCategories();
  }, [tenantId]);

  return (
    <TypeaheadBox
      {...props}
      // @ts-expect-error TS(2322) FIXME: Type '{ options: undefined; info: any; fetching: u... Remove this comment to see the full error message
      options={categories}
      info={
        // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        (selectedCategory as $TSFixMe)?.new || (values[name] as $TSFixMe)?.new
          ? (intl as $TSFixMe).formatMessage({
              id: "product_category_typeahead.new_info",
            })
          : null
      }
      fetching={fetching}
      loadOptions={loadProductCategories}
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      loadOptionsOnMount={!values[name]}
    />
  );
}

ProductCategoryTypeahead.defaultProps = defaultProps;

export default injectIntl(withNotifier(withApi(ProductCategoryTypeahead)));
